export const seoCourseFragment = `
  fragment seoCourseFragment on CourseRecord {
    audienceDescription
    code
    description {
      blocks
      links
      value
    }
    keywords
    name
    skills
  }
`;
